const AbstractVerifoneResponseRecord = require('./AbstractVerifoneResponseRecord');

class VerifoneSubmitOfflineTransactionsResponseRecord extends AbstractVerifoneResponseRecord {

}

module.exports = VerifoneSubmitOfflineTransactionsResponseRecord;
